import request from '@/utils/request'

// 查询工会列表
export function listTradeUnion(query) {
  return request({
    url: '/trade/trade/union/list',
    method: 'get',
    params: query,
  })
}

// 查询工会分页
export function pageTradeUnion(query) {
  return request({
    url: '/trade/trade/union/page',
    method: 'get',
    params: query,
  })
}

// 查询工会详细
export function getTradeUnion(data) {
  return request({
    url: '/trade/trade/union/detail',
    method: 'get',
    params: data,
  })
}

// 新增工会
export function addTradeUnion(data) {
  return request({
    url: '/trade/trade/union/add',
    method: 'post',
    data: data,
  })
}

// 修改工会
export function updateTradeUnion(data) {
  return request({
    url: '/trade/trade/union/edit',
    method: 'post',
    data: data,
  })
}

// 删除工会
export function delTradeUnion(data) {
  return request({
    url: '/trade/trade/union/delete',
    method: 'post',
    data: data,
  })
}
